import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import { ChatThread, ChatComposer } from "@/components/SupportChat";
import { Empty } from "./shared";

export const SupportTab = ({ onChanged }) => {
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(null);
  const [messages, setMessages] = useState([]);

  const loadThreads = () => api.get("/admin/support/threads").then((r) => setThreads(r.data)).catch(() => {});
  const openThread = (userId) => {
    setActive(userId);
    api.get(`/admin/support/${userId}`).then((r) => { setMessages(r.data); loadThreads(); onChanged?.(); }).catch(() => {});
  };
  useEffect(() => {
    loadThreads();
    const id = setInterval(() => { loadThreads(); if (active) api.get(`/admin/support/${active}`).then((r) => setMessages(r.data)).catch(() => {}); }, 15000);
    return () => clearInterval(id);
  }, [active]);

  const reply = async (text) => {
    const { data } = await api.post(`/admin/support/${active}`, { text });
    setMessages((m) => [...m, data]);
    loadThreads();
  };
  const current = threads.find((t) => t.user_id === active);

  return (
    <div data-testid="admin-support-tab">
      <div className="mb-8">
        <h2 className="font-display text-2xl tracking-tight">Investor Support</h2>
        <p className="font-accent text-[9px] tracking-[0.2em] uppercase text-white/35 mt-1" data-testid="support-threads-count">{threads.length} conversations · {threads.reduce((s, t) => s + t.unread, 0)} unread</p>
      </div>
      <div className="grid lg:grid-cols-5 border border-white/10">
        <ul className="lg:col-span-2 border-r border-white/10 max-h-[460px] overflow-y-auto" data-testid="support-threads">
          {threads.length === 0 && <Empty testId="support-threads-empty" text="No investor questions yet." />}
          {threads.map((t) => (
            <li key={t.user_id}>
              <button data-testid={`support-thread-${t.user_id}`} onClick={() => openThread(t.user_id)} className={`w-full text-left px-5 py-4 border-b border-white/5 hover:bg-white/[0.03] transition-colors ${active === t.user_id ? "bg-[#D4AF37]/5 border-l-2 border-l-[#D4AF37]" : ""}`}>
                <div className="flex items-center justify-between gap-2">
                  <p className="text-sm text-white truncate">{t.user_name}</p>
                  {t.unread > 0 && <span data-testid={`support-unread-${t.user_id}`} className="min-w-[18px] h-[18px] px-1 rounded-full bg-[#D4AF37] text-black text-[10px] font-bold flex items-center justify-center">{t.unread}</span>}
                </div>
                <p className="text-xs text-white/45 truncate mt-1">{t.last_sender === "admin" ? "You: " : ""}{t.last_text}</p>
                <p className="text-[10px] text-white/30 mt-1">{fmtDate(t.last_at)}</p>
              </button>
            </li>
          ))}
        </ul>
        <div className="lg:col-span-3 flex flex-col">
          {active ? (
            <>
              <div className="px-5 py-3 border-b border-white/10 flex items-center justify-between">
                <div>
                  <p className="text-sm text-white" data-testid="support-active-name">{current?.user_name}</p>
                  <p className="text-xs text-white/40">{current?.user_email}</p>
                </div>
                <a href={`mailto:${current?.user_email}`} className="font-accent text-[9px] tracking-[0.2em] uppercase text-white/40 hover:text-[#D4AF37]">Email</a>
              </div>
              <ChatThread messages={messages} mine="admin" testId="admin-support-thread" />
              <ChatComposer onSend={reply} placeholder="Type your reply… investor is notified by email + in-app" testId="admin-support-composer" />
            </>
          ) : (
            <p className="text-sm text-white/40 p-10 text-center" data-testid="support-select-hint">Select a conversation to read and reply.</p>
          )}
        </div>
      </div>
    </div>
  );
};
